import { UI } from '@genial/components';
import React from 'react';

import { useGlobalAssetContext } from '../../contexts';
import { OperationType } from '../../contexts/constants';

export const OperationSwitch = () => {
  const { selectedTab, setSearchTerm, setFiltersToApply, setProductsTabs, isMobile } =
    useGlobalAssetContext();

  const operationsTabs = selectedTab.operationsTabs;

  if (operationsTabs.length <= 1) {
    return <></>;
  }

  const handleChangeOperationType = (operationType: OperationType) => {
    setSearchTerm('');
    setFiltersToApply({});
    setProductsTabs((prevTabs) =>
      prevTabs.map((tab) => {
        if (tab.id !== selectedTab.id) {
          return tab;
        }
        const selectedOperation = operationsTabs.find(
          (operation) => operation.operationType === operationType
        );
        return { ...tab, ...selectedOperation, selected: true };
      })
    );
  };

  const operationsOptions = operationsTabs.map((tab) => ({
    key: tab.operationType,
    label: tab.operationName,
  }));

  return (
    <UI.TabSwitch
      stackStyleProps={{ flex: 'none', pt: isMobile ? 'stack.xxxs' : 0, alignSelf: 'end' }}
      widthFull={isMobile}
      testId={`tab-switch-${selectedTab.id}-operation`}
      tabs={operationsOptions}
      selectedTab={selectedTab.operationType}
      onTabPress={(value) => handleChangeOperationType(value as OperationType)}
      renderTabsOnly
      containerRadius="full"
      buttonStyleProps={{
        desktop: {
          width: isMobile ? '45%' : '85px', // Mobile design is equal to desktop
          borderRadius: 'full',
        },
      }}
    />
  );
};
